import { TextHighlight } from "./text-highlight";
import type { Ref } from "react";

type MobileListboxOptionProperties = {
  index: number;
  code: string;
  name: string;
  indent?: boolean;
  inputValue: string;
  active: boolean;
  selected: boolean;
  setSize: number;
  getOptionId: (code: string, index: number) => string;
  onSelect: (index: number) => void;
  onActive: (index: number) => void;
  ref?: Ref<HTMLLIElement>;
};

export const MobileListboxOption = ({
  index,
  code,
  name,
  indent,
  inputValue,
  active,
  setSize,
  selected,
  getOptionId,
  onSelect,
  onActive,
  ref,
}: MobileListboxOptionProperties) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events -- listbox options are not focusable; keyboard is handled by combobox via aria-activedescendant
  <li
    aria-posinset={index + 1}
    aria-selected={selected}
    aria-setsize={setSize}
    className="flex w-full cursor-pointer px-4 py-2 text-royal-blue data-[current=true]:bg-royal-blue data-[current=true]:text-white"
    data-current={active}
    data-index={index}
    id={getOptionId(code, index)}
    key={`${code}-${index.toString()}`}
    onClick={() => {
      onSelect(index);
    }}
    onMouseMove={() => {
      onActive(index);
    }}
    ref={ref}
    role="option"
    tabIndex={-1}
  >
    {indent && <span aria-hidden className="mr-0.5 before:content-['\2014']" />}
    <TextHighlight highlight={inputValue}>{name}</TextHighlight>
  </li>
);
